import { tagName } from "@ember-decorators/component"
import Component from "@glimmer/component"

@tagName("")
export default class PlanbookMenuPrimaryTitleComponent extends Component {}
